import {SettingsParamsType} from '../../types/createStylesParams'
import {
  formSettingsParams,
  FormSettingsParams,
} from '../../components-shared/Settings/FormDesign/settingsParams'

import {displaySettingsParams, DisplaySettingsParams} from './Settings/Tabs/Display/settingsParams'
import {layoutSettingsParams, LayoutSettingsParams} from './Settings/Tabs/Layout/settingsParams'
import {textsSettingsParams, TextsSettingsParams} from './Settings/Tabs/Texts/settingsParams'

export type SettingsParams = DisplaySettingsParams &
  FormSettingsParams &
  LayoutSettingsParams &
  TextsSettingsParams

export const settingsParams: SettingsParamsType<SettingsParams> = {
  ...displaySettingsParams,
  ...formSettingsParams,
  ...layoutSettingsParams,
  ...textsSettingsParams,
}
export default settingsParams
